import axios from "axios";
import BACKEND_URL from "../../lib/apiConfig";

export const shopOrderApi = `${BACKEND_URL}/api/service-shop-orders`;
export const SHOP_LABELS = { in_shop: "In Shop", shop_work_incomplete: "Work incomplete", ready_to_redeliver: "Work complete" };
export const isShopCall = call => !!SHOP_LABELS[call?.status] || ["In Shop", "Shop Work Incomplete"].includes(call?.airtable_status);
export const shopError = error => typeof error.response?.data?.detail === "string" ? error.response.data.detail : "Could not save the work order. Please try again.";
export const saveShopOrder = (id, payload) => axios.put(`${shopOrderApi}/${id}`, payload);

export const shopCallPatch = order => ({
  status: "in_shop",
  airtable_status: "In Shop",
  shop_work_status: order.work_status || ({ shop_work_incomplete: "incomplete", ready_to_redeliver: "complete" }[order.status]) || "pending",
  shop_assigned_tech_name: order.assigned_tech_name,
  shop_assigned_tech_id: order.assigned_tech_id,
});